module.exports = __webpack_public_path__ + "blogwriting.svg?6a6b9f21e0c51bfcfd49e097449dc38a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/blogwriting.svg
// module id = 41
// module chunks = 0